<template>
  <div>
    <div class="leaders-event__body active">
      <ul class="leaders-event__main-row">
        <li class="col-2 tac">Rank</li>
        <li class="col-5">Rider</li>
        <li class="col-5">Average score</li>
      </ul>

      <ul v-for="(draw) in draws" :key="draw.rank">
        <li class="col-2 tac">{{ draw.rank }}</li>
        <li class="col-5">
          <link-rider :draw="draw"/>
        </li>
        <li class="col-5">
          {{ draw.average_score }}
        </li>
      </ul>
    </div>
    <pagination
      v-if="meta && meta.last_page > 1"
      :page="currentPage"
      :total-pages="(meta && meta.last_page) ? meta.last_page : 0"
      :on-change="handlePageChange"
      :color="appearances.schema_color"
      class="paginate-leaderboard"
      />
  </div>
</template>

<script>

import pagination from '@/components/Pagination'
import fetchData from '../../../../mixins/apiHelpers'
import LinkRider from './Links/LinkRider'

export default {
  inject: ['entity'],
  components: {
    pagination,
    'link-rider': LinkRider
  },
  data() {
    return {
      draws: null,
      meta: null,
      currentPage: 1
    }
  },
  props: {
    appearances: {
      type: Object,
      required: false
    }
  },
  methods: {
    getRiders() {
      fetchData(`${this.$api}/leaders/drafts/${this.entity.id}/riders`, (response) => {
        this.draws = response.data.data.draws
        this.meta = response.data.meta
        // eslint-disable-next-line
        // console.log(this.draws)
      }, this, {
        params: {
          page: this.currentPage
        }
      })
    },
    handlePageChange(page) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page
        }
      })
    }
  },
  watch: {
    '$route.query.page': {
      immediate: true,
      handler(page) {
        this.currentPage = Number(page) || 1
        this.getRiders()
      }
    }
  }
}
</script>

<style scoped>
  .leaders a {
    color: var(--apperances-color) !important;
  }

  .leaders__count {
    color: var(--apperances-color) !important;
  }

  .leaders__tabs {
    border-color: var(--apperances-color) !important;
  }

  .leaders__tab {
    color: var(--apperances-color) !important;
    border-left-color: var(--apperances-color) !important;
  }

  .leaders .leaders__tab.active {
    background-color: var(--apperances-color) !important;
    color: var(--white) !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/Leaders/Listing/components/DraftRidersList.vue